// The seven four-cell pieces and their rotation rules.
//
// Grid coordinates everywhere in the engine: x grows to the right, y grows
// DOWN (row 0 is the top of the well). Each shape is listed in its spawn
// orientation inside an n x n box; rotating clockwise maps (x, y) to
// (n - 1 - y, x) within that box.
//
// Rotation uses the standard "super rotation" wall kicks so pieces turn the
// way anyone who has played a falling-block game expects. The kick tables
// below are written y-up, the way they are usually published, and flipped
// to y-down in kicksFor().

export const SHAPES = {
  I: { size: 4, cells: [[0, 1], [1, 1], [2, 1], [3, 1]] },
  J: { size: 3, cells: [[0, 0], [0, 1], [1, 1], [2, 1]] },
  L: { size: 3, cells: [[2, 0], [0, 1], [1, 1], [2, 1]] },
  O: { size: 4, cells: [[1, 0], [2, 0], [1, 1], [2, 1]] },
  S: { size: 3, cells: [[1, 0], [2, 0], [0, 1], [1, 1]] },
  T: { size: 3, cells: [[1, 0], [0, 1], [1, 1], [2, 1]] },
  Z: { size: 3, cells: [[0, 0], [1, 0], [1, 1], [2, 1]] },
};

export const SHAPE_NAMES = Object.keys(SHAPES);

function rotateCW(cells, size) {
  return cells.map(([x, y]) => [size - 1 - y, x]);
}

// ROTATIONS[shape][rot] = the four [x, y] offsets for that orientation.
export const ROTATIONS = Object.fromEntries(SHAPE_NAMES.map((name) => {
  const { size, cells } = SHAPES[name];
  const states = [cells];
  for (let i = 1; i < 4; i += 1) {
    // The O piece looks the same every way round; keeping its cells fixed
    // stops it from wobbling inside its 4x4 box when "rotated".
    states.push(name === 'O' ? cells : rotateCW(states[i - 1], size));
  }
  return [name, states];
}));

const JLSTZ_KICKS = {
  '0>1': [[0, 0], [-1, 0], [-1, 1], [0, -2], [-1, -2]],
  '1>0': [[0, 0], [1, 0], [1, -1], [0, 2], [1, 2]],
  '1>2': [[0, 0], [1, 0], [1, -1], [0, 2], [1, 2]],
  '2>1': [[0, 0], [-1, 0], [-1, 1], [0, -2], [-1, -2]],
  '2>3': [[0, 0], [1, 0], [1, 1], [0, -2], [1, -2]],
  '3>2': [[0, 0], [-1, 0], [-1, -1], [0, 2], [-1, 2]],
  '3>0': [[0, 0], [-1, 0], [-1, -1], [0, 2], [-1, 2]],
  '0>3': [[0, 0], [1, 0], [1, 1], [0, -2], [1, -2]],
};

const I_KICKS = {
  '0>1': [[0, 0], [-2, 0], [1, 0], [-2, -1], [1, 2]],
  '1>0': [[0, 0], [2, 0], [-1, 0], [2, 1], [-1, -2]],
  '1>2': [[0, 0], [-1, 0], [2, 0], [-1, 2], [2, -1]],
  '2>1': [[0, 0], [1, 0], [-2, 0], [1, -2], [-2, 1]],
  '2>3': [[0, 0], [2, 0], [-1, 0], [2, 1], [-1, -2]],
  '3>2': [[0, 0], [-2, 0], [1, 0], [-2, -1], [1, 2]],
  '3>0': [[0, 0], [1, 0], [-2, 0], [1, -2], [-2, 1]],
  '0>3': [[0, 0], [-1, 0], [2, 0], [-1, 2], [2, -1]],
};

export function kicksFor(shape, from, to) {
  if (shape === 'O') return [[0, 0]];
  const table = shape === 'I' ? I_KICKS : JLSTZ_KICKS;
  return table[`${from}>${to}`].map(([dx, dy]) => [dx, -dy]);
}

export function pieceCells(piece) {
  return ROTATIONS[piece.shape][piece.rot].map(([x, y]) => [piece.x + x, piece.y + y]);
}
